<template>
  <div class="container">
    <InfiniteScroll imageWidth="1200" />
  </div>
</template>

<script>
import InfiniteScroll from '../components/InfiniteScroll';

export default {
  name: 'PoisListView',
  components: { InfiniteScroll },
};
</script>

<style scoped></style>
